export const appusers = {
  appusersSearch: 'Buscar'
}
